import { Button, Container } from '@mantine/core';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { useDispatch } from 'react-redux';
import { refreshGameList } from '@/store/features/gameSlice';
import styles from './404.module.scss';

export default function Custom404() {
    const router = useRouter();
    const dispatch = useDispatch();

    const handleBackHome = () => {
        dispatch(refreshGameList());
        router.replace('/');
    };

    return (
        <div className={styles.error_page}>
            <Container size="md" className={styles.container}>
                <div className={styles.image_wrapper}>
                    <Image
                        src="/images/icons/common/404.png"
                        alt="404 Error"
                        width={600}
                        height={200}
                        className={styles.error_image}
                    />
                    <div className={styles.remind}>
                        No Data
                    </div>
                </div>
                <Button
                    size="lg"
                    variant="gradient"
                    className={styles.back_button}
                    onClick={handleBackHome}
                >
                    Back To Home
                </Button>
            </Container>
        </div>
    );
}
